function out(level, file, func, logjson) {
 // console.log("[" + level + "] " + file + " " + func + " " + JSON.stringify(logjson))
}

function verbose(file, func, logjson) {
  out("V", file, func, logjson)
}

function debug(file, func, logjson) {
  out("D", file, func, logjson)
}

function info(file, func, logjson) {
  out("I", file, func, logjson)
}

function warn(file, func, logjson) {
  out("W", file, func, logjson)
}

function error(file, func, logjson) {
  out("E", file, func, logjson)
}
export default {
  v: verbose,
  d: debug,
  i: info,
  w: warn,
  e: error
}
